import { Injectable, NgZone } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImagePopupService {

  private initialized = false;
  private overlay!: HTMLElement;
  private container!: HTMLElement;
  private img!: HTMLImageElement;
  private info!: HTMLElement;

  constructor(private zone: NgZone) {}

  /**
   * Inicializa el popup (solo una vez)
   */
  init(): void {
    if (this.initialized) return;
    this.initialized = true;

    // Ejecutar fuera de Angular (evita detecciones innecesarias)
    this.zone.runOutsideAngular(() => {
      this.createPopup();
      this.attachGlobalListeners();
    });
  }

  ngAfterViewInit(): void {
    this.overlay = document.querySelector('.overlay') as HTMLElement;
    this.container = document.querySelector('.container-modal') as HTMLElement;
  }

  /**
   * Crea el DOM del popup
   */
  private createPopup(): void {
    if (document.getElementById('img-popup-overlay')) {
      this.overlay = document.getElementById('img-popup-overlay')!;
      return;
    }

    this.overlay = document.createElement('div');
    this.overlay.id = 'img-popup-overlay';

    this.container = document.createElement('div');
    this.container.id = 'img-popup-container';

    this.img = document.createElement('img');

    this.info = document.createElement('div');
    this.info.id = 'img-popup-info';

    this.container.appendChild(this.img);
    this.container.appendChild(this.info);
    this.overlay.appendChild(this.container);
    document.body.appendChild(this.overlay);
  }

  /**
   * Listeners globales
   */
  private attachGlobalListeners(): void {

    // Delegación de eventos para thumbnails
    document.addEventListener('click', e => {
      const thumb = (e.target as HTMLElement).closest('.thumb-popup');
      if (!thumb) return;

      const full = thumb.getAttribute('data-full');
      if (!full) return;

      const titulo = thumb.getAttribute('data-titulo');
      const texto1 = thumb.getAttribute('data-texto1');
      const texto2 = thumb.getAttribute('data-texto2');

      this.open(full, titulo, texto1, texto2);
    });

    // Cerrar al hacer click fuera
    this.overlay.addEventListener('click', e => {
      if (e.target === this.overlay) this.close();
    });

    // Cerrar con Escape
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') this.close();
    });
  }

  /**
   * Abre el popup
   */
  open(
    src: string,
    titulo?: string | null,
    texto1?: string | null,
    texto2?: string | null
  ): void {

    if (this.info) {
      this.info.innerHTML = `
        <div>${titulo || ''}</div>
        <div class="small">${texto1 || ''}</div>
        <div class="small">${texto2 || ''}</div>
      `;
    }

    this.img.onload = () => {
      this.overlay.style.display = 'flex';
      void this.overlay.offsetWidth;
      this.overlay.classList.add('show');
      this.container.classList.add('show');
    };

    this.img.onerror = () => {
      console.warn('No se pudo cargar la imagen:', src);
    };

    this.img.src = src;
  }

  /**
   * Cierra el popup
   */
  close(): void {
    if (!this.overlay || !this.container) {
      return;
    }

    this.overlay.classList.remove('show');
    this.container.classList.remove('show');

    setTimeout(() => {
      if (this.overlay) {
        this.overlay.style.display = 'none';
      }
    }, 250);
  }
}
